export class handleLocalStorage{
  static setTokenItem(data){
    window.localStorage.setItem('userToken', data);
  }
  static getTokenItem(){
    return window.localStorage.getItem('userToken');
  }
  static removeTokenItem(){
    window.localStorage.removeItem('userToken');
  }
  // 通用
  static setSomeItem(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
  static getSomeItem(key){
    return JSON.parse(window.localStorage.getItem(key));
  }
  static removeSomeItem(key){
    window.localStorage.removeItem(key);
  }
}